document.addEventListener('DOMContentLoaded', () => {
  window.affirm?.ui.ready(function() {
    if (!window.affirm) {
      console.error('Affirm not loaded');
      return;
    }

    const { affirm } = window;

    // Grab whichever price is on the page (PDP vs cart)
    const productPriceEl = document.querySelector<HTMLElement>('.single-product__price.js-product-price');
    const cartPriceEl = document.querySelector<HTMLElement>('.cart__summary-total-val.js-cart-price');
    const priceEl = productPriceEl || cartPriceEl;

    if (!priceEl) {
      console.error('Price element not found');
      return;
    }

    const priceStr = priceEl.getAttribute('data-price') as string;
    const price = Number(priceStr);
    const pageType = document.querySelector<HTMLElement>('main.cart') ? 'cart' : 'product';

    // Only present on PDP
    const internalSkuEl = document.querySelector<HTMLElement>('.single-product__sku.js-sp-sku');
    const internalSku = internalSkuEl?.getAttribute('data-internal-sku') || undefined;
    const productTypeEl = document.querySelector<HTMLElement>('main.product .js-product');
    const productType = productTypeEl?.getAttribute('data-product-type') || undefined;

    const promoComponent = affirm.ui.components.create('promo', {
      amount: price * 100, // Convert to cents
      pageType: pageType,
      affirmLogoType: 'logo',
      affirmLogoColor: 'blue',
      category: productType,
      // brand: 'Brand',
      sku: internalSku,
      // promoId: 'promoId',
      // learnMoreShow: true,
    });

    promoComponent.render('.js-affirm');

    // Add mutation observer to watch for price changes
    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-price') {
          const target = mutation.target as HTMLElement;
          const priceStr = target.dataset.price as string;
          const price = Number(priceStr);
          // console.debug('Price changed to: ', price);
          const priceCents = price * 100;

          promoComponent.update({
            amount: priceCents,
          });
        }
      });
    });

    // Start observing the priceEl for attribute changes
    mutationObserver.observe(priceEl, { attributes: true });
  });
});
